import React from 'react';
import Form from '@lt/components/components/Form';
import classnames from 'classnames';
import styles from './input.module.css';

type InputProps = React.ComponentProps<typeof Form.Input> & {
  className?: string;
};

export const Input = ({ className, ...props }: InputProps) => (
  <Form.Input className={classnames(styles.input, className)} {...props} />
);
